"use strict"

import { Platform, Dimensions } from "react-native"
import { isIphoneX } from "react-native-iphone-x-helper"
import config from "app/config"

class Device {}

Object.defineProperties(Device, {
  width: {
    get: () => {
      if (Platform.OS === "web") {
        return Math.min(window.innerWidth, config.env.MAX_WEB_WIDTH)
      }
      return Dimensions.get("window").width
    },
  },

  height: {
    get: () => {
      if (Platform.OS === "web") {
        return Math.min(window.innerHeight, config.env.MAX_WEB_HEIGHT)
      }
      return Dimensions.get("window").height
    },
  },

  isMobile: {
    get: () => {
      return /Mobi/i.test(navigator.userAgent)
    },
  },

  isIphoneX: {
    get: () => isIphoneX(),
  },
})

export default Device
